export const videoPlayer = () => {
    // if (document.querySelector('#player')) {
    //     console.log('test');
    //     new Plyr('#player', { controls: [] }); // Hides controls
    // }
    var player = videojs('player', { controls: false, autoplay: true });
}